export default "__VITE_ASSET__10afe6b4__"